import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';

import { NationalityActions, NationalityInitProps } from './nationality.actions';
import * as NationalitySelectors from './nationality.selectors';

@Injectable({ providedIn: 'root' })
export class NationalityFacade {
  /**
   * Combine pieces of state using createSelector,
   * and expose them as observables through the facade.
   */
  loaded$ = this.store.pipe(select(NationalitySelectors.getNationalityLoaded));
  allNationality$ = this.store.pipe(select(NationalitySelectors.getAllNationality));
  allNationalityEntities$ = this.store.pipe(select(NationalitySelectors.getNationalityEntities));
  nationalitySingpassMap$ = this.store.pipe(select(NationalitySelectors.getNationalitySingpassMap));

  constructor(private readonly store: Store) {}

  /**
   * Use the initialization action to perform one
   * or more tasks in your Effects.
   */
  init(props: NationalityInitProps): void {
    this.store.dispatch(NationalityActions.init(props));
  }
}
